import cx from 'classnames'
import { useContext, useEffect, useMemo, useState } from 'react'

import { StringsContext } from '@lib/strings-context'
import { UserContext } from '@lib/user/context'
import { getHasUserPurchasePermission } from '@lib/user/helpers'
import { FrameBuilderSettingsContext } from '@frame-builder/contexts/settings-context'
import { FrameBuilderCommittedStateContext } from '@frame-builder/contexts/state-context'
import { getStatePriceWithDiscount } from '@frame-builder/lib/state-price'

import ProductActionsGuest from '@blocks/product/product-actions-guest'
import PricingControls from './pricing-controls'
import AddToCartButton from './utility/add-to-cart-button'

interface FooterProps {
  getProductImageDataUrl: () => string | undefined
  className?: string
}

const Footer = ({ getProductImageDataUrl, className }: FooterProps) => {
  const strings = useContext(StringsContext)
  const { committedState } = useContext(FrameBuilderCommittedStateContext)
  const { frameBuilderConfiguration, frameBuilderType } = useContext(
    FrameBuilderSettingsContext,
  )
  const { user } = useContext(UserContext)

  const [quantity, setQuantity] = useState<string>('1')
  const [pathname, setPathname] = useState('/')

  const price = useMemo<number>(() => {
    return getStatePriceWithDiscount(
      frameBuilderType,
      frameBuilderConfiguration,
      committedState,
    )
  }, [committedState, frameBuilderConfiguration, frameBuilderType])

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [])

  const hasUserPurchasePermission = getHasUserPurchasePermission(user)
  const hasActions = !!user && hasUserPurchasePermission
  const hasGuestActions = !!user && !hasUserPurchasePermission

  return (
    <div
      className={cx(
        'flex flex-col bg-white',
        {
          'border-t': hasActions,
        },
        className,
      )}
    >
      {hasActions && (
        <>
          <PricingControls
            price={price}
            quantity={quantity}
            setQuantity={setQuantity}
            className="my-7"
          />
          <AddToCartButton
            quantity={quantity}
            getProductImageDataUrl={getProductImageDataUrl}
          >
            {strings.buttonAddToCart}
          </AddToCartButton>
        </>
      )}

      {hasGuestActions && <ProductActionsGuest returnTo={pathname} />}
    </div>
  )
}

export default Footer
